import { TableCellProps } from '@mui/material'
import { StyledTableCell } from './styles'

export const TableCell = ({ ...props }: TableCellProps) => {
  return <StyledTableCell {...props} />
}
